import type { ChangeEvent } from "react";
import { Checkbox, TableCell, TableRow, Theme } from "@mui/material";
import { TableHeaderData } from "../investorOverview/types";
import theme from "../../themes/default";
import { OnboardedCustomerObj } from "../../redux-store/types/investorProfile";

export const selectMemberTableHeader: TableHeaderData[] = [
    { id: "select", label: "", align: "center", isSortable: false },
    { id: "name", label: "NAME", align: "center", isSortable: false },
    {
        id: "clientCode",
        label: "CLIENT CODE",
        align: "center",
        isSortable: false,
    },
    {
        id: "investorPan",
        label: "INVESTOR PAN",
        align: "center",
        isSortable: false,
    },
    {
        id: "phoneNumber",
        label: "PHONE NUMBER",
        align: "center",
        isSortable: false,
    },
    { id: "email", label: "EMAIL", align: "center", isSortable: false },
];

export interface SelectMemberTableBodyProps {
    data: OnboardedCustomerObj[];
    selectedMemberIds: string[];
    familyMemberIds: string[];
    onCheckboxClick: (memberId: string, checked: boolean) => void;
}

export default function SelectMemberTableBody({
    data,
    selectedMemberIds,
    onCheckboxClick,
    familyMemberIds,
}: SelectMemberTableBodyProps): JSX.Element {
    return (
        <>
            {data.map((row) => (
                <TableRow
                    key={row.customer}
                    hover
                    sx={{
                        cursor: "pointer",
                        "&:last-child td": { border: 0 },
                    }}
                    onClick={(e) => {
                        if (
                            (e.target as HTMLElement).closest(
                                'input[type="checkbox"]'
                            ) != null
                        )
                            return;
                        if (familyMemberIds.includes(row.customer))
                            return;
                        onCheckboxClick(
                            row.customer,
                            !selectedMemberIds.includes(row.customer)
                        );
                    }}
                >
                    <TableCell
                        align="center"
                        sx={{
                            borderBottom: (t: Theme) =>
                                `1px solid ${t.palette.grey[100]}`,
                        }}
                        padding="checkbox"
                    >
                        <Checkbox
                            sx={{
                                padding: "0px",
                                "&:hover": { bgcolor: "transparent" },
                                color:
                                    theme.palette.customColors
                                        ?.checkBoxUnchecked ??
                                    theme.palette.grey[700],
                                "&.Mui-checked": {
                                    color:
                                        theme.palette.primary[500] ??
                                        theme.palette.primary.main,
                                },
                                "&.Mui-disabled": {
                                    color: theme.palette.grey[400],
                                },
                            }}
                            checked={selectedMemberIds.includes(row.customer)}
                            disabled={familyMemberIds.includes(row.customer)}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                e.stopPropagation();
                                onCheckboxClick(row.customer, e.target.checked);
                            }}
                        />
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={{
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: (t: Theme) =>
                                `1px solid ${t.palette.grey[100]}`,
                        }}
                    >
                        {row.customerName}
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={{
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: (t: Theme) =>
                                `1px solid ${t.palette.grey[100]}`,
                        }}
                    >
                        {row.customer}
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={{
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: (t: Theme) =>
                                `1px solid ${t.palette.grey[100]}`,
                        }}
                    >
                        {row.panNumber}
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={{
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: (t: Theme) =>
                                `1px solid ${t.palette.grey[100]}`,
                        }}
                    >
                        {row.mobileNo}
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={{
                            ...theme.typography.body_400,
                            fontWeight: 500,
                            borderBottom: (t: Theme) =>
                                `1px solid ${t.palette.grey[100]}`,
                        }}
                    >
                        {row.emailId}
                    </TableCell>
                </TableRow>
            ))}
        </>
    );
}
